import React, { Component } from "react";
import ParticipantInfo from "./ParticipantInfo";

export default class ReviewCycleRow extends Component {
  render() {
    const participants = this.props.participants;
    // Check if the form is rejected in current cycle
    const rejectingOfficer = participants.find((p) => p.action_status === 4);
    let hasRejected = false;
    return (
      <div className="row body-info">
        <div className="col-md-1"></div>
        {/* Create five slots for request, check, verify, approve and referback */}
        {/* Note that there is no slot for reject */}
        {[0, 1, 2, 22, 5].map((actionStatus) => {
          // Check if there is a participant who perform current action
          const participant = participants.find(
            (p) => p.action_status === actionStatus
          );
          // If there is no participant who perform current action,
          // check if current action is reject
          const isReject =
            !participant && rejectingOfficer && actionStatus !== 5;
          if (isReject && !hasRejected) {
            hasRejected = true;
            return (
              <ParticipantInfo
                participant={rejectingOfficer}
                actionStatus={actionStatus}
                isRejectingOfficer={true}
              />
            );
          } else if (!participant) {
            return <ParticipantInfo actionStatus={actionStatus} />; // Empty Info
          } else {
            return (
              <ParticipantInfo
                participant={participant}
                actionStatus={actionStatus}
              />
            );
          }
        })}
      </div>
    );
  }
}
